import { mapProductTypeToProductCategory } from '@grandvisionhq/svc-tealium/utils';
import { isDefined } from '@grandvisionhq/utils';
import { mapFacetsToTealiumFacetValue } from './map-facets-to-tealium-facet-value.js';
import { mapProductToTealiumProperties } from './map-product-to-tealium-properties.js';

const mapProductsToTealiumViewProperties = (products, appliedFilters, total, productType)=>{
    let pageTitle = '';
    const mappedProducts = products.filter(isDefined).map((product)=>[
            product.masterVariant.sku,
            mapProductToTealiumProperties(product)
        ]
    );
    if (productType) {
        pageTitle = mapProductTypeToProductCategory(productType);
    }
    const facets = mapFacetsToTealiumFacetValue(appliedFilters);
    return {
        id: 'VirtualPage-View',
        Page_Type: 'Plp',
        Page_Section1: 'Catalog',
        Page_Section2: pageTitle,
        Products: Object.fromEntries(mappedProducts),
        Search_ResultItemsQnt: `${total}`,
        Search_FacetValues_String: facets
    };
};

export { mapProductsToTealiumViewProperties };
//# sourceMappingURL=map-products-to-tealium-view-properties.js.map
